// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-wrapper {
  border: hidden;
  height: 100%;
  border: none;
  width: 1280px;
}
.checkout-content {
  border: hidden;
  height: 100%;
  border: none;
  width: 1280px;
}
.checkout-card {
  border: hidden;
  padding: 0;
  display: flex;
  flex-direction: row;
  background-color: rgba(250, 250, 250, 1);
  border: none;
  width: 1280px;
}
.checkout-config-root {
  display: flex;
  width: 100%;
}
.side-panel {
  width: 309px;
  background: white;
  border-radius: 0px 0px 6px 6px;
  border: 1px solid #e7e8f2;
  background: #fff;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.02);
  border-top: none;
  color: "white";
  display: flex;
  flex-direction: column;
}
.checkout-config-panel-contnet {
  overflow-y: auto;
  overflow-x: auto;
  height: 81dvh;
}

.mobile-desktop-selection-panel {
  height: 10vh;
  padding: 20px;
}
.toggle-area {
  display: flex;
  width: 98px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0px 4px 14px 0px rgba(40, 40, 40, 0.07);
  justify-content: space-around;
  align-items: center;
}

.toggle-area:hover {
  cursor: pointer;
}

.publish-btn {
  display: flex;
  height: 40px;
  min-width: 60px;
  padding: 0px 24px;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  background: var(--generic-primary-accent, #403e9f);
  box-shadow: 0px 4px 14px 0px rgba(115, 115, 115, 0.13);
}

.publish-btn:hover {
  cursor: pointer;
}

/* .main-content {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 80vh;
}

.mobile-version {
  display: flex;
  overflow: auto;
  align-items: flex-start;
}

.desktop-version {
  overflow: auto;
  display: flex;
  flex-grow: 1;
} */
/* @media only screen and (min-width: 1240px) {
    .checkout-wrapper {
        overflow: hidden;
    }
    .checkout-content {
        overflow: hidden;
    }
    .checkout-card {
        overflow: hidden;
    }
} */

.main-content {
  display: flex;
  height: 80vh;
  width: 100%;
  align-items: flex-start;
  overflow-x: hidden;
}

.mobile-version {
  display: flex;
  justify-content: center;
  overflow: hidden;
  height: 100%;
  margin: auto;
}

.desktop-version {
  overflow-y: hidden;
  overflow-x: hidden;
  min-width: 1280px;
  height: 100%;
}

.mobile-version iframe {
  border: 2px;
  box-shadow: 0px 8px 16px 0px #40404033;
  border-radius: 20px;
}

.desktop-version iframe {
  border: 2px;
  box-shadow: 0px 8px 16px 0px #40404033;
  border-radius: 20px;
}

input[type="color"] {
  border-radius: 5px;
  padding: 0;
  border: 5px solid #ddd;
}

input[type="color"]::-moz-color-swatch {
  border: none;
}

input[type="color"]::-webkit-color-swatch-wrapper {
  padding: 0;
  border-radius: 0;
}

input[type="color"]::-webkit-color-swatch {
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/checkout/checkout.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mDAAmD;EACnD,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kDAAkD;EAClD,sDAAsD;AACxD;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;GAiBG;AACH;;;;;;;;;;GAUG;;AAEH;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".checkout-wrapper {\n  border: hidden;\n  height: 100%;\n  border: none;\n  width: 1280px;\n}\n.checkout-content {\n  border: hidden;\n  height: 100%;\n  border: none;\n  width: 1280px;\n}\n.checkout-card {\n  border: hidden;\n  padding: 0;\n  display: flex;\n  flex-direction: row;\n  background-color: rgba(250, 250, 250, 1);\n  border: none;\n  width: 1280px;\n}\n.checkout-config-root {\n  display: flex;\n  width: 100%;\n}\n.side-panel {\n  width: 309px;\n  background: white;\n  border-radius: 0px 0px 6px 6px;\n  border: 1px solid #e7e8f2;\n  background: #fff;\n  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.02);\n  border-top: none;\n  color: \"white\";\n  display: flex;\n  flex-direction: column;\n}\n.checkout-config-panel-contnet {\n  overflow-y: auto;\n  overflow-x: auto;\n  height: 81dvh;\n}\n\n.mobile-desktop-selection-panel {\n  height: 10vh;\n  padding: 20px;\n}\n.toggle-area {\n  display: flex;\n  width: 98px;\n  height: 44px;\n  flex-shrink: 0;\n  border-radius: 6px;\n  background: #fff;\n  box-shadow: 0px 4px 14px 0px rgba(40, 40, 40, 0.07);\n  justify-content: space-around;\n  align-items: center;\n}\n\n.toggle-area:hover {\n  cursor: pointer;\n}\n\n.publish-btn {\n  display: flex;\n  height: 40px;\n  min-width: 60px;\n  padding: 0px 24px;\n  align-items: center;\n  gap: 10px;\n  border-radius: 6px;\n  background: var(--generic-primary-accent, #403e9f);\n  box-shadow: 0px 4px 14px 0px rgba(115, 115, 115, 0.13);\n}\n\n.publish-btn:hover {\n  cursor: pointer;\n}\n\n/* .main-content {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  height: 80vh;\n}\n\n.mobile-version {\n  display: flex;\n  overflow: auto;\n  align-items: flex-start;\n}\n\n.desktop-version {\n  overflow: auto;\n  display: flex;\n  flex-grow: 1;\n} */\n/* @media only screen and (min-width: 1240px) {\n    .checkout-wrapper {\n        overflow: hidden;\n    }\n    .checkout-content {\n        overflow: hidden;\n    }\n    .checkout-card {\n        overflow: hidden;\n    }\n} */\n\n.main-content {\n  display: flex;\n  height: 80vh;\n  width: 100%;\n  align-items: flex-start;\n  overflow-x: hidden;\n}\n\n.mobile-version {\n  display: flex;\n  justify-content: center;\n  overflow: hidden;\n  height: 100%;\n  margin: auto;\n}\n\n.desktop-version {\n  overflow-y: hidden;\n  overflow-x: hidden;\n  min-width: 1280px;\n  height: 100%;\n}\n\n.mobile-version iframe {\n  border: 2px;\n  box-shadow: 0px 8px 16px 0px #40404033;\n  border-radius: 20px;\n}\n\n.desktop-version iframe {\n  border: 2px;\n  box-shadow: 0px 8px 16px 0px #40404033;\n  border-radius: 20px;\n}\n\ninput[type=\"color\"] {\n  border-radius: 5px;\n  padding: 0;\n  border: 5px solid #ddd;\n}\n\ninput[type=\"color\"]::-moz-color-swatch {\n  border: none;\n}\n\ninput[type=\"color\"]::-webkit-color-swatch-wrapper {\n  padding: 0;\n  border-radius: 0;\n}\n\ninput[type=\"color\"]::-webkit-color-swatch {\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
